import React from 'react';
import { MoreVertical, ListMinus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

/**
 * Account actions overflow. Remove (Market list) is distinct from Disengage
 * (parked but still mine — Analytics → Disengaged).
 */
export default function AccountOverflowMenu({ onRemove, disabled = false, className = '' }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          disabled={disabled}
          className={`h-8 w-8 text-[#5C6B7A] hover:text-[#0A1A2F] ${className}`}
          aria-label="Account actions"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <MoreVertical className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        onClick={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
      >
        <DropdownMenuItem
          disabled={disabled}
          className="text-[#5C6B7A] focus:text-[#0A1A2F] cursor-pointer"
          onSelect={(e) => {
            e.preventDefault();
            onRemove?.();
          }}
        >
          <ListMinus className="w-4 h-4" />
          Remove
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
